import React from 'react';

export default function FullTitleValue(props) {
    let className = "horizontalScreen "
    if (props.className) {
        className = className + props.className
    }
    if (props.onClick) {
        className = className + ' clickable'
    }
    return (<div onClick={props.onClick} className={className}>
        <div className={props.titleClassName ? props.titleClassName + " marginLeftRightSmall singleLine fullWidth" :
            "mediumText marginRightSmall singleLine fullWidth"}>
            {props.title}
        </div>
        {(props.value && props.onClick) ?
            <div className={props.valueClassName ?
                props.valueClassName + " marginLeftRightSmall singleLine blueColor" :
                "mediumTextBold marginRightSmall singleLine blueColor"}>
                {props.value}
            </div> :
            <div className={props.valueClassName ?
                props.valueClassName + " marginLeftRightSmall singleLine" :
                "mediumTextBold marginRightSmall singleLine"}>
                {props.value}
            </div>
        }
        {props.secondValue &&
        <div className={props.secondValueClassName ?
            props.secondValueClassName + " marginLeftRightSmall singleLine" :
            "mediumTextBold marginRightSmall singleLine"}>
            {props.secondValue}
        </div>
        }
    </div>)
}